import React, { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import Patients from "../../modules/Patients";
import { Tooltip } from "@mui/material";
import { BiEditAlt } from "react-icons/bi";
import EditPatientJobDialog from "../../components/Dialogs/EditPatientJobDialog";
import { Button, Col, Form, Row } from "react-bootstrap";
import { DatePicker, Select, Space } from "antd";
import { Option } from "antd/lib/mentions";
import CustomButtons from "../ui-elements/Buttons/CustomButtons";
import moment from "moment";
// import 'moment-timezone';
import { Modal } from "react-bootstrap";
import Skelton from "../../components/Skelton/Skelton";
import { AiOutlineDown } from "react-icons/ai";
import { AiOutlineDownload } from "react-icons/ai";
import { AiOutlineClose } from "react-icons/ai";
import CustomTextFilterComponent from "./CustomTextFilterComponent";
import PDFViewer from "./PDFviewer";
import LdcApi from "../../LdcApis";
import { Spin } from "antd";
import { GrView } from "react-icons/gr";
import dayjs from "dayjs";
import { FaImages } from "react-icons/fa";
import EditPatientComplaintsDialog from "../../components/Dialogs/EditPatientComplaintsDialog";
import EditDoctorShortcutsDialog from "../../components/Dialogs/EditDoctorShortcutsDialog";

import { use } from "react";
import DoctorNotesForm from "../forms/DoctorNotesForm";
import EditDoctorNotesForm from "../forms/EditDoctorNotesForm";
import { CloseFullscreenRounded } from "@mui/icons-material";
const userInfo = JSON.parse(localStorage.getItem("user_info"));

function DoctorNotesTable({
  assignedData,
  complaintListData,
  getComplaintsDetailsPatient,
  categoryListStatus,
  getCaegoryListStatus,
  roleListStatus,
  getRoleListStatus,
  loading1,
  loading2,
  loading3,

  // setShowPatientForm,
}) {
  console.log("complaintListData", complaintListData);
  console.log("getComplaintsDetailsPatient", getComplaintsDetailsPatient());

  const [showPatientForm, setShowPatientForm] = useState(false);
  const gridRef = useRef();
  const [statusSelect, setStatusSelect] = useState("");
  const dateFormat = "DD-MM-YYYY";
  const { RangePicker } = DatePicker;
  const [showEditJobPatient, setShowEditJobPatient] = useState(false);
  const [patientId, setPatientId] = useState("");
  const [editJobData, setEditJobData] = useState({});
  const [selectCategory, setCategory] = useState("");
  const [roleSelect, setRoleSelect] = useState("");
  const [selectAllBtn, setSelectAllBtn] = useState(true);
  // const [complaintListData, setComplaintListData] = useState([]); // Default to empty array
  const [rowData, setRowData] = useState(complaintListData);
  const [imagePopUp, setImagePopUp] = useState(false);
  const [imageLink, setImageLink] = useState([]);
  const [showPopUp, setShowPopUp] = useState(false);
  const [currentMessage, setCurrentMessage] = useState("");
  const [buttonDetails, setButtonDetails] = useState(null);
  const [firstSelectField, setFirstSelectField] = useState("");
  const [currentClkButton, setCurrentClkBtn] = useState("");
  const [loadingForDelete, setLoadingForDelete] = useState(false);
  const [currentObj, setCurrentObj] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfView, setPdfView] = useState("");
  const [viewPDFModal, setViewPDFModal] = useState(false);
  const viewOnly =
    userInfo.roleName.replace(/\s/g, "").toUpperCase() === "VIEWONLY";
  const prevObj = null;
  // useEffect(() => {
  //   if (categoryListStatus.length > 0 && roleListStatus.length > 0) {
  //     const obj = {};
  //     categoryListStatus.forEach((item) => {
  //       obj[item.category] = 0;
  //     })
  //     roleListStatus.forEach((item) => {
  //       obj[item.doctorId] = 0;
  //     })
  //     obj["All"]=0;
  //     setButtonDetails({ ...obj });
  //   }
  // }, [categoryListStatus, roleListStatus])
  useEffect(() => {
    switch (userInfo.roleName) {
      case "Administration":
        setRoleSelect("Admin");
        break;
      case "Booking Team":
        setRoleSelect("Booking Team");
        break;
      case "Clinic Assistant":
        setRoleSelect("Clinic Team");
        break;
      case "Manager":
        setRoleSelect("Manager");
        break;
      case "Doctors":
        setRoleSelect("Doctor");
        break;
      default:
        if (userInfo.userType === "D") {
          setRoleSelect("Doctor");
          break;
        } else {
          setRoleSelect("");
        }
    }
  }, [userInfo]);

  console.log("showEditJobPatient", showEditJobPatient);
  useEffect(() => {
    if (complaintListData) {
      setRowData(complaintListData);
    }
  }, [complaintListData]);
  // useEffect(() => {
  //   console.log('first=-=-=-=--->>>>>', editJobData);
  //   if (editJobData) {
  //     setShowEditJobPatient(true);
  //   }
  // }, [editJobData]);

  const modalFunction = () => {
    console.log("editJobData", editJobData);
    if (editJobData) {
      setShowEditJobPatient(true);
    }
  };

  useEffect(() => {}, [buttonDetails]);
  function formatDateToYYYYMMDD(date) {
    // Get the current date and time in the UK time zone
    // Ensure the parameter is a Date object; if not, use the current date
    const now = moment().tz("Europe/London");
    const currentDate = date instanceof Date ? date : new Date();
    // Extract year, month, and day
    // Calculate 1 month ago from the current date
    const year = currentDate.getFullYear();
    const oneMonthsAgo = now.clone().subtract(3, "months");
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const day = currentDate.getDate().toString().padStart(2, "0");
    // Format the date
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  const now = new Date();
  const oneMonthsAgo = new Date();
  oneMonthsAgo.setMonth(oneMonthsAgo.getMonth() - 1);

  const defaultValue = [
    dayjs(formatDateToYYYYMMDD(oneMonthsAgo)),
    dayjs(formatDateToYYYYMMDD(now)),
  ]; // RangePicker takes an array of two moment objects

  // // State to hold the selected date range
  const [selectedRange, setSelectedRange] = useState(defaultValue);

  // // Event handler for date range change
  const handleDateChange = (dates) => {
    setSelectedRange(dates);
  };

  const ViewAttachment = (params) => {
    setViewPDFModal(true);
    setPdfView(params);
  };
  const closePDFView = () => {
    setViewPDFModal(false);
  };

  const handleChange = (value) => {
    setStatusSelect(value);

    // const newData = complaintListData.filter((e) => e.status === value);
    // setRowData(newData);
  };
  const viewBtnClick = (src) => {
    setViewPDFModal(true);
    setImageLink(src);
  };

  const openModalForTestReading = (fieldName, patient, obj) => {
    setShowPopUp(true);
    if (fieldName === "Outcome" && obj) {
      const [date, time] = obj.createdOn.split("T");
      const [year, month, day] = date.split("-");
      const formattedDate = `${day}/${month}/${year.substring(2, year.length)}`;
      const formattedTime = time.slice(0, 5);
      setCurrentMessage({
        fieldName: `${fieldName} :: ${patient}`,
      });
      setCurrentObj({
        cUser: obj.cUser,
        formattedDate,
        formattedTime,
        outcomes: obj.outComes,
        getJobListOutCome: obj.getJobListOutCome,
      });
    } else {
      setCurrentMessage({
        fieldName: `${fieldName} :: ${patient}`,
        text: obj,
      });
    }
  };

  const [columnDefs] = useState([
    // {
    //   headerName: "Notes",
    //   field: "notes",
    //   width: 220,
    //   minWidth: 230,
    //   filter: true,
    //   cellRenderer: function (params) {
    //     return (
    //       <div
    //         className="d-flex align-items-center actions_ag_grid"
    //         style={{
    //           // textTransform: 'capitalize',
    //           display: "flex",
    //           justifyContent: "space-between",
    //           width: "100%",
    //         }}
    //       >
    //         <div style={{ flex: 1 }}>{params.data.notes}</div>
    //         <div style={{ marginLeft: "10px" }}>
    //           <Tooltip placement="left" title="Edit">
    //             <BiEditAlt
    //               onClick={() => {
    //                 if (params.data) {
    //                 //  setShowPatientForm(true)
    //                   // setShowEditJobPatient(false); // Close first
    //                   setTimeout(() => {
    //                     // setPatientId(params.data.id);
    //                     setEditJobData(params.data);
    //                      setShowPatientForm(true);
    //                     // setShowEditJobPatient(true); // Ensure modal opens
    //                   }, 100); // Delay to allow state update
    //                 }
    //               }}
    //               // onClick={() => {
    //               //   if (
    //               //     // !viewOnly &&
    //               //     params.data
    //               //     // Object.keys(params.data).length > 0
    //               //   ) {
    //               //     setPatientId(params.data.patientId);
    //               //     setEditJobData(params.data);
    //               //     // setShowEditJobPatient(true);

    //               //     // modalFunction();

    //               //     console.log('Editing Data:', params.data);
    //               //   } else {
    //               //     console.log('No data available to edit.');
    //               //   }
    //               // }}
    //               // onClick={() => {
    //               //   if (!viewOnly) {
    //               //     setEditJobData(params.data);
    //               //     console.log("first", viewOnly);
    //               //     setShowEditJobPatient(true);
    //               //   }
    //               // }}
    //               className="mx-2 edit_btn"
    //               style={{
    //                 fontSize: "1.4rem",
    //                 cursor: "pointer",
    //               }}
    //             />
    //           </Tooltip>
    //         </div>
    //       </div>
    //     );
    //   },
    // },
    {
      headerName: "Template Name",
      field: "templateName",
      width: 180,
      // maxWidth: 180,
      minWidth: 80,
      filter: false,
       filter: true,
      // filterFramework: CustomTextFilterComponent,
      cellRenderer: function (params) {
        console.log("params", params);
        return (
          <div
            className="d-flex align-items-center actions_ag_grid"
            style={{
              textTransform: "capitalize",
            }}
          >
            {params?.value ? params.value : ""}
          </div>
        );
      },
      headerClass: "multi-line-header",
    },
    {
      headerName: "Shortcut",
      field: "shortcuts",
      width: 180,
      // maxWidth: 180,
      minWidth: 120,
      filter: true,
      // filterFramework: CustomTextFilterComponent,
      cellRenderer: function (params) {
        console.log("params", params);
        return (
          <div
            className="d-flex align-items-center actions_ag_grid"
            style={{
              textTransform: "capitalize",
            }}
          >
            {params?.value ? params.value : ""}
            <div style={{ marginLeft: "10px" }}>
              <Tooltip placement="left" title="Edit">
                <BiEditAlt
                  onClick={() => {
                    if (params.data) {
                      console.log('params', params)
                      //  setShowPatientForm(true)
                      // setShowEditJobPatient(false); // Close first
                      setTimeout(() => {
                        // setPatientId(params.data.id);
                        setEditJobData(params.data);
                        setShowPatientForm(true);
                        // setShowEditJobPatient(true); // Ensure modal opens
                      }, 100); // Delay to allow state update
                    }
                  }}
                  className="mx-2 edit_btn"
                  style={{
                    fontSize: "1.4rem",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            </div>
          </div>
        );
      },
      headerClass: "multi-line-header",
    },
    {
      headerName: "Description",
      field: "description",
      width: 180,
      // maxWidth: 180,
      minWidth: 80,
      filter: true,
      // filterFramework: CustomTextFilterComponent,
      cellRenderer: function (params) {
        console.log("params", params);
        return (
          <div
            className="d-flex align-items-center actions_ag_grid"
            style={{
              textTransform: "capitalize",
            }}
          >
            {params?.value ? params.value : ""}
          </div>
        );
      },
      headerClass: "multi-line-header",
    },
  ]);

  const defaultColDef = {
    filter: true,
    sortable: true,
    floatingFilter: true,
    flex: 1,
    resizable: true,
    height: 100,
    minWidth: 99,
    autoHeight: true,
    wrapText: true,
    enableColResize: true,
    autoSizeColumns: true,
  };

  function calculateDaysLeft(dueDate) {
    // Parse the due date string into a Date object
    const dueDateTime = new Date(dueDate);

    // Get the current date
    const currentDate = new Date();

    // Calculate the difference in milliseconds
    const differenceMs = dueDateTime - currentDate;

    // Convert milliseconds to days
    const differenceDays = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));

    // Set the font color based on whether the deadline is exceeded
    const fontColor = differenceDays < 0 ? "red" : "black";

    return { daysLeft: differenceDays, fontColor };
  }
  const fetchFilteredData = () => {
    const startDate = moment(selectedRange[0].$d).format("YYYY-MM-DD");
    const endDate = moment(selectedRange[1].$d).format("YYYY-MM-DD");

    Patients.GetDoctorNoteShortcutAll((response) => {
      console.log("responserererere sdfasd", response.data);
      if (response?.status === "success" && response?.data?.data) {
        let newData = response.data.data.map((item) => ({
          
          userName: item.noteCreatedBy,
        

          templateName: item.templateName,
          description: item.description,
          shortTerm: item.shortcuts,
          id :item?.id,
          templateId :item?.id,

 
        }));

        setRowData(newData);
        getComplaintsDetailsPatient(response?.data);
      } else {
        console.log("first");
        setRowData([]);
      }
    });
  };

  useEffect(() => {
    // Only call the API if all necessary parameters are available
    if (selectedRange || statusSelect || roleSelect) {
      fetchFilteredData();
    }
  }, [selectedRange, selectCategory, statusSelect, roleSelect]); // dependencies to trigger the effect on changes

  const filterByCategory = (value) => {
    // Update category button value
    setCategory(value);

    // // If the selected category is not 'All', trigger the API call
    // if (value !== "") {
    //   setSelectAllBtn(false);
    // } else {
    //   // If 'All' is selected, reset the button states
    //   setCategory("");
    //   setRoleSelect("");
    //   setSelectAllBtn(true);
    // }

    // Ensure 'Assigned To' (role) is only reset when a specific condition is met
    if (value === "") {
      // 'All' category selected
      setSelectAllBtn(true);

      // Preserve the role selection unless it's explicitly necessary to reset
      if (selectCategory !== "") {
        console.log("Preserving Assigned To (roleSelect):", roleSelect); // Debug
      }
    } else {
      // Specific category selected
      setSelectAllBtn(false);
    }

    const startDate = moment(selectedRange[0].$d).format("YYYY-MM-DD");
    const endDate = moment(selectedRange[1].$d).format("YYYY-MM-DD");

    console.log("Sending Start Date:", startDate);
    console.log("Sending End Date:", endDate);
    console.log("Selected Category:", value); // Log selected category
    console.log("Selected Role:", roleSelect); // Log selected role
    console.log("complaintListData", complaintListData);
    console.log("assignedData", assignedData);
    console.log("getRoleListStatus", getRoleListStatus);
    console.log("getCaegoryListStatus", getCaegoryListStatus);

    // Call the API every time a new category is selected
    Patients.getJobListForPatientByCategory(
      value,
      startDate,
      endDate,
      statusSelect,
      roleSelect,
      (response) => {
        console.log("API response:", response); // Inspect the full response
        if (
          response?.status === "success" &&
          response?.data &&
          Array?.isArray(response?.data?.jobList)
        ) {
          console.log("Job List Data:", response.data.jobList); // Inspect jobList data

          let newData = [];

          // Check if jobList exists and is an array
          if (Array?.isArray(response?.data?.jobList)) {
            // const ukStartDate = moment(selectedRange[0].$d)
            //   .tz("Europe/London")
            //   .startOf("day");
            // const ukEndDate = moment(selectedRange[1].$d)
            //   .tz("Europe/London")
            //   .endOf("day");

            newData = response?.data?.jobList?.filter((item) => {
              const createdOn = moment(item.createdOn).format("YYYY-MM-DD"); // Normalize createdOn to YYYY-MM-DD format
              return createdOn >= startDate && createdOn <= endDate; // Compare directly with startDate and endDate
            });

            console.log("Filtered newData:", newData);

            // Apply status filter if selected
            if (statusSelect) {
              newData = newData.filter((e) => e.status === statusSelect);
            }
          } else {
            console.error("jobList is not an array or is missing");
          }

          setRowData([...newData]); // Update state with filtered data
          getComplaintsDetailsPatient(response?.data);
          console.log("response.data", response.data);
        } else {
          console.warn("No success status or missing data");
          setRowData([]); // Clear rowData if no success
          getComplaintsDetailsPatient({
            complaintListData: [],
            complaintStatus: [],
          });
        }

        console.log("Final rowData:", rowData);
      }
    );
  };

  const resetAllStates = () => {
    // Reset all state variables here
    setRowData([]); // Example: Reset table data
    setCategory(""); // Reset category button
    setSelectAllBtn(false); // Reset 'All' button
    setRoleSelect(""); // Reset role select
    setStatusSelect(""); // Reset status filter
    // setComplaintListData([]); // Reset job list data
    // setBoxShown([]); // Reset any displayed box data
    setSelectedRange(defaultValue); // Reset date range picker
    console.log("All states have been reset!");
  };

  const filterByRole = (value) => {
    // console.log(value);
    // setSelectAllBtn(false);
    // if (value === '' || roleSelect === value) {
    //   setRoleSelect('');
    // } else {
    //   setCurrentClkBtn('role');
    //   setRoleSelect(value);
    // }
  };
  // const handleClose = () => {
  //   setImagePopUp(false);
  //   setImageLink('');
  // };

  const handleCloseReadPopup = () => {
    // setShowPopUp(false);
    // setCurrentMessage(null);
    // setCurrentObj(null);
  };

  const getRowStyle = (params) => {
    // console.log('params ----------->', params);
    const dueDate = new Date(params.data.duedate);
    const today = new Date();
    // params.data.duedate == 'Open
    if (dueDate < today && params.data.status !== "Completed") {
      return { background: "#f4bdbd", color: "black" }; // Adjust the background color as needed
    } else if (params.node.rowIndex % 2 === 0) {
      return { background: "#f2f2f2" }; // Even rows
    } else {
      return null; // Odd rows // return null; // Default style
    }
  };
  const handleAssignedTo = (val) => {
    console.log(val);
  };
  const handleCategory = (val) => {};
  return !loading1 && !loading2 && !loading3 ? (
    <div style={{ marginTop: "0" }}>
      <Row style={{ justifyContent: "space-between" }}>
        <Col style={{ display: "flex", justifyContent: "flex-end" }}>
          {/* <Row style={{ width: "100%", justifyContent: "flex-end" }}> */}

          <CustomButtons
            // onClick={() => window.location.reload(false)}
            onClick={resetAllStates}
            variant="primary"
            name="Refresh"
            style={{
              height: "33px",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
            }}
          />
        </Col>
      </Row>

      {pdfLoading && (
        <div className="view_pdf_loading">
          <Spin size="large" className="view_pdf_loading_spin" />
        </div>
      )}
      <div
        className="ag-theme-alpine mt-2"
        style={{ height: "90vh", width: "100%" }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          animateRows={true}
          // onGridReady={onGridReady}
          pagination={true}
          paginationPageSize={50}
          debounceVerticalScrollbar={true}
          paginationAutoPageSize={true}
          getRowStyle={getRowStyle} // Set the getRowStyle callback
        />
      </div>

      <EditDoctorNotesForm
        assignedData={assignedData}
        getComplaintsDetailsPatient={getComplaintsDetailsPatient}
        // patientJobDetails={patientJobDetails}
        showPatientForm={showPatientForm}
        setShowPatientForm={setShowPatientForm}
        getCaegoryListStatus={getCaegoryListStatus}
        getRoleListStatus={getRoleListStatus}
        // patientLoader={patientLoader}
        editJobData={editJobData}
      />

      {/* <EditDoctorShortcutsDialog
        // assignedData={assignedData}
        // handleClose={() => setShowEditJobPatient(false)}
        showEditJobPatient={showEditJobPatient}
        setShowEditJobPatient={(value) => setShowEditJobPatient(value)}
        editJobData={editJobData ? editJobData : null}
        patientId={patientId}
        selectedRange={selectedRange}
        getComplaintsDetailsPatient={getComplaintsDetailsPatient}
        getCaegoryListStatus={getCaegoryListStatus}
        getRoleListStatus={getRoleListStatus}
        setLoadingForDelete={setLoadingForDelete}
        loadingForDelete={loadingForDelete}
        roleListStatus={roleListStatus}
      /> */}

      <Modal
        size="md"
        show={loadingForDelete}
        centered
        className="labloader_modal"
      >
        <Modal.Body>
          <div className="spinner-container">
            <div className={`loading-spinner`}></div>
          </div>
        </Modal.Body>
      </Modal>
      {currentMessage && (
        <Modal
          size="md"
          show={showPopUp}
          onHide={() => {
            handleCloseReadPopup();
          }}
          centered
          className="taskDetails_popup_modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{currentMessage?.fieldName}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: "10px 25px" }}>
            <>
              {currentObj && currentObj?.outcomes && (
                <p
                  style={{
                    textAlign: "justify",
                    lineHeight: "25px",
                    marginBottom: "15px",
                  }}
                >
                  {`[${currentObj.cUser?.replace(/\b\w/g, function (match) {
                    return match.toUpperCase();
                  })} ${currentObj.formattedDate} ${currentObj.formattedTime}]`}
                  <br />
                  <span>
                    {currentObj?.outcomes?.charAt(0).toUpperCase() +
                      currentObj?.outcomes?.slice(1)}
                  </span>
                </p>
              )}
              {/* {currentObj &&
                currentObj.getJobListOutCome.map((item) => {
                  const [date, time] = item.modifiedOn.split("T");
                  const [year, month, day] = date.split("-");
                  const formattedDate = `${day}/${month}/${year.substring(2, year.length)}`;
                  const formattedTime = time.slice(0, 5);
                  return (
                    <>
                      {
                        <p
                          style={{
                            textAlign: "justify",
                            lineHeight: "25px",
                            marginBottom: "15px",
                          }}
                        >
                          {`[${item.userName.replace(/\b\w/g, function (match) {
                            return match.toUpperCase();
                          })} ${formattedDate} ${formattedTime}]`}
                          <br />
                          <span>
                            {item.message.charAt(0).toUpperCase() +
                              item.message.slice(1)}
                          </span>
                        </p>
                      }
                    </>
                  );
                })} */}
              {currentObj === null && (
                <p
                  style={{
                    textAlign: "justify",
                    lineHeight: "25px",
                    marginBottom: "15px",
                  }}
                >
                  {currentMessage.text.charAt(0).toUpperCase() +
                    currentMessage.text.slice(1)}
                </p>
              )}
            </>
          </Modal.Body>
        </Modal>
      )}
      {/* <Modal size="xl" show={imagePopUp} onHide={() => {
          handleClose()
        }} className="image_popup" centered >
          <Modal.Header closeButton>
            <Modal.Title>View</Modal.Title>
          </Modal.Header>
          <Modal.Body className="" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            
          </Modal.Body>
        </Modal> */}
      <Modal size="xl" show={viewPDFModal} onHide={closePDFView}>
        <Modal.Header closeButton>
          <>
            <Modal.Title>View Attachments</Modal.Title>
          </>
        </Modal.Header>
        <Modal.Body
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {/* {imageLink.map((item) => {
            if (item.filePath.includes(".pdf")) {
              return <PDFViewer pdfUrl={item.filePath} />;
            } else {
              return (
                <div style={{ width: "max-content", height: "max-content" }}>
                  <img
                    src={item.filePath}
                    alt="image1"
                    style={{
                      minWidth: "100%",
                      height: "550px",
                      maxWidth: "1100px",
                    }}
                  />
                </div>
              );
            }
          })} */}
          {/* {(imageLink.includes(".pdf") ? <PDFViewer pdfUrl={imageLink} /> : <div style={{ width: "max-content", height: "max-content", }}>
              <img src={imageLink} alt="image1" style={{ width: "100%", height: "550px" }} />
            </div>)} */}
          {pdfLoading ? (
            <>
              <Spin />
            </>
          ) : (
            <>
              {console.log(pdfView)}
              {pdfView?.includes(".pdf") ? (
                <PDFViewer pdfUrl={pdfView} />
              ) : (
                <div style={{ width: "max-content", height: "max-content" }}>
                  <img
                    src={pdfView}
                    alt=" "
                    style={{ width: "100%", height: "550px" }}
                  />
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  ) : (
    <Skelton />
  );
}

export default DoctorNotesTable;
